export default __webpack_public_path__ + "static/media/800X900 1.aa1833a9.png";